/**
 * Home page
 */

// React
import React, { useEffect, useState } from 'react';

// Libraries
import { useNavigate, useLocation } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';

// Material
import { Box } from '@mui/material';

// Component
import AppBanner from 'components/AppBanner';

// Router
import ROUTES from 'configs/route';

// Common styles
import {
  Content,
  Divider,
  HeaderContainer,
  PageContainer,
  RegisterButton,
  ServiceItem,
  ServicesContainer,
  Title,
  WrapperIcon,
  CustomGrid,
} from 'styles';

// Recoil
import { loadingAtom } from 'recoil/LoadingRecoil';

// Utils
import { AWS_S3, SSO_URL, STORAGE_KEYS } from 'utils/constants';

// Services
import AuthService from 'services/AuthService';

// Component
const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const location = useLocation();
  const setIsLoading = useSetRecoilState(loadingAtom);
  const queryParams = new URLSearchParams(location.search);
  const authenCode = queryParams.get('code');
  const clientID = SSO_URL.CLIENT_ID;

  useEffect(() => {
    const handleAuth = async () => {
      if (authenCode && clientID) {
        try {
          setIsLoading(true);
          const res = await AuthService.getToken({ auth_code: authenCode, client_id: clientID });

          localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, JSON.stringify(res?.access_token));
          localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, JSON.stringify(res?.refresh_token));

          setIsLoading(false);
          navigate(ROUTES.USER_INFO);
        } catch (error) {
          setIsLoading(false);
          navigate(ROUTES.ERROR);
        }
      }
    };

    handleAuth();
  }, [authenCode, clientID]);

  useEffect(() => {
    const getServices = async () => {
      try {
        setIsLoading(true);
        const res = await AuthService.getServices();
        setServices(res);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };
    if (!authenCode) {
      getServices();
    }
  }, []);

  const handleClickRegister = () => {
    navigate(ROUTES.LOGIN);
  };

  return (
    <PageContainer>
      <AppBanner />
      <ServicesContainer>
        <CustomGrid
          servicesLength={services?.length || 0}
          container
          columnSpacing={{ xs: '10px', md: '20px' }}
          rowSpacing="20px"
        >
          {services?.map((service: any, index) => (
            <ServiceItem key={index} size={{ xs: 6, md: 3 }} borderTop={`solid ${service?.color}`}>
              <HeaderContainer>
                <WrapperIcon src={`${AWS_S3.BASE_URL}/${service?.icon}`} alt="Image service" />
                <Box>
                  <Title color={service?.color}>{service?.title}</Title>
                </Box>
              </HeaderContainer>
              <Divider />
              <Box>
                <Content>{service.body}</Content>
              </Box>
              <RegisterButton
                type="button"
                onClick={() => handleClickRegister()}
                variant="outlined"
                sx={{
                  '&:hover': {
                    borderColor: service?.color,
                    backgroundColor: '#FFFFFF',
                  },
                }}
              >
                利用登録
              </RegisterButton>
            </ServiceItem>
          ))}
        </CustomGrid>
      </ServicesContainer>
    </PageContainer>
  );
};

export default HomePage;
